import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { OptionsUI, OptionUI } from '@calendly/ui/components/select';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { getLabelText } from '../utils';
const allOptionsDropdownContainerCss = "anqmu87";
const AllOptionsDropdownContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(allOptionsDropdownContainerCss, props.className)} />;
});
const iconWrapperCss = "i1mcwhud";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const locationOptionWrapperCss = "lvbb349";
const LocationOptionWrapper = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(locationOptionWrapperCss, props.className)} />);
const dropdownDividerWrapperCss = "d528ge0";
const DropdownDividerWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dropdownDividerWrapperCss, props.className)} />;
});
const LocationOptionBody = ({
  kind
}) => <>
    <IconWrapper>
      <LocationIcon kind={kind} />
    </IconWrapper>
    <BodyText as="span">{getLabelText(kind)}</BodyText>
  </>;
const LocationOption = ({
  kind,
  updateAction
}) => <LocationOptionWrapper onClick={() => updateAction(kind)}>
    <LocationOptionBody kind={kind} />
  </LocationOptionWrapper>;
const MobileOption = ({
  updateSelectedKind,
  kind
}) => <OptionUI onClick={() => updateSelectedKind(kind)}>
    <LocationOptionBody kind={kind} />
  </OptionUI>;
const Divider = () => <DropdownDividerWrapper>
    <BodyText size="medium" as="div" weight="bold">
      {I18n.t('publisher.event_type_editor.sections.event_details.fields.location.dropdown.subheader')}
    </BodyText>
  </DropdownDividerWrapper>;
const MobileLocationList = forwardRef(({
  updateSelectedKind,
  nonWebConferencingKinds,
  webConferencingKinds
}, ref) => <OptionsUI ref={ref}>
    {nonWebConferencingKinds.map(kind => <MobileOption key={kind} kind={kind} updateSelectedKind={updateSelectedKind} />)}
    <Divider />
    {webConferencingKinds.map(kind => <MobileOption key={kind} kind={kind} updateSelectedKind={updateSelectedKind} />)}
  </OptionsUI>);
export const LocationOptionList = forwardRef(({
  updateSelectedKind,
  nonWebConferencingKinds,
  webConferencingKinds,
  className
}, ref) => {
  const isPhone = useDeviceType('isPhone');
  if (isPhone) {
    return <MobileLocationList ref={ref} updateSelectedKind={updateSelectedKind} nonWebConferencingKinds={nonWebConferencingKinds} webConferencingKinds={webConferencingKinds} />;
  }
  return <AllOptionsDropdownContainer ref={ref} className={className}>
      {nonWebConferencingKinds.map(kind => <LocationOption key={kind} kind={kind} updateAction={updateSelectedKind} />)}
      <Divider />
      {webConferencingKinds.map(kind => <LocationOption key={kind} kind={kind} updateAction={updateSelectedKind} />)}
    </AllOptionsDropdownContainer>;
});

require("./location_option_list.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location_option_list.js");